import { FC } from 'react'
import mclasses from '../../../../styles/modal.module.css'
import Modal from '@common/Modal'
import { crmApi } from '@/api'
import { useAddAlert } from '@/hooks/useAddAlert'
import { IcoRemove } from '@/utils/icons'
import Button from '@UI/New/Button'
import { Lead, Notification } from '@/api/types/crm.types'
import { isError } from '@/helpers/checkQuery'

interface SendNotificationModalProps {
  lead: Lead
  notification?: Notification | null
  open: boolean
  onClose: () => void
  onSuccess?: () => void
  // onDismiss: () => void
}

const SendNotificationModal: FC<SendNotificationModalProps> = ({
  lead,
  notification,
  open,
  onSuccess,
  onClose,
}) => {
  const addAlert = useAddAlert()

  const handleConfirm = async () => {
    if (!notification) {
      addAlert({
        title: 'Ошибка',
        text: 'Не выбрано уведомление',
        type: 'error',
      })
      onClose()
      return
    }

    crmApi
      .sendNotification({ lead_id: lead.id, notification_id: notification.id })
      .then((res) => {
        if (isError(res)) throw new Error()
        addAlert({
          title: 'Успешно',
          text: `Уведомление успешно отправлено`,
          type: 'success',
        })
        onSuccess && onSuccess()
      })
      .catch((error) => {
        addAlert({
          title: 'Ошибка',
          text: 'Ошибка отправки уведомления',
          type: 'error',
        })
        onClose()
      })
  }

  return (
    <Modal
      active={open}
      className={mclasses.modalWrapper as any}
      setActive={() => onClose()}
    >
      <div className={mclasses.modalContainer}>
        <div className={mclasses.modalHeader}>
          <div className={mclasses.modalTitleContainer}>
            <span className={mclasses.modalHeaderTitle}>
              Отправить уведомление?
            </span>
          </div>
          <div className={mclasses.closeIcon} onClick={() => onClose()}>
            <IcoRemove />
          </div>
        </div>
        <div className={mclasses.formWrapper}>
          {notification && <p>Уведомление “{notification.name}”</p>}
        </div>
        <div className={mclasses.actions}>
          <Button color="gray" onClick={() => onClose()}>
            Отменить
          </Button>
          <Button color="primary" onClick={() => handleConfirm()}>
            Подтвердить
          </Button>
        </div>
      </div>
    </Modal>
  )
}

export default SendNotificationModal
